const getApplicationEnvironment = () => {
  const isProductionEnv =
    process.env["NEXT_PUBLIC_APPLICATION_ENVIRONMENT"] === "production";
  const isStagingEnv =
    process.env["NEXT_PUBLIC_APPLICATION_ENVIRONMENT"] === "staging";
  const isDevEnv =
    process.env["NEXT_PUBLIC_APPLICATION_ENVIRONMENT"] === "development";
  const isFeatureEnv = !isProductionEnv && !isStagingEnv && !isDevEnv;

  return {
    isProductionEnv,
    isStagingEnv,
    isDevEnv,
    isFeatureEnv,
    environment:
      process.env["NEXT_PUBLIC_APPLICATION_ENVIRONMENT"] || "feature",
  };
};

export default getApplicationEnvironment;
